export default __webpack_public_path__ + "static/media/img3.5367a8fa.svg";